import React, { forwardRef } from 'react'
import { preventOrphans, formatTextWithOrphans } from 'src/helpers/typography'

export type HighlightVariant = 'highlight' | 'body'

interface IHighLightProps {
  className?: string
  children: React.ReactNode
  isFullWidth?: boolean
  widthClass?: string
  variant?: HighlightVariant
  disableBalance?: boolean
}

const HighLight = forwardRef<HTMLHeadingElement, IHighLightProps>(
  ({ className, children, isFullWidth = false, widthClass, variant = 'highlight', disableBalance = false }, ref) => {
    const textAlignClass = className?.includes('text-center') ? 'text-center' : 'text-left'
    const paragraphClass =
      variant === 'body'
        ? `font-palanquin font-semibold text-body-medium lg:text-body-medium xl:text-body-large text-black dark:text-white/80 whitespace-normal ${textAlignClass} ${disableBalance ? '' : '[text-wrap:pretty] lg:[text-wrap:balance]'}`
        : `font-palanquin font-bold text-body-large xl:text-title-medium whitespace-normal ${textAlignClass} ${disableBalance ? '' : '[text-wrap:pretty] lg:[text-wrap:balance]'}`

    const renderParagraphs = () => {
      if (typeof children === 'string') {
        const processed = preventOrphans(children)
        const paragraphs = processed.split(/\n\s*\n/)
        if (paragraphs.length > 1) {
          return (
            <div className="space-y-4">
              {paragraphs.map((p, i) => (
                <p key={i} className={paragraphClass}>
                  {p}
                </p>
              ))}
            </div>
          )
        }
        return (
          <p className={paragraphClass}>
            {processed}
          </p>
        )
      }
      return (
        <p className={paragraphClass}>
          {formatTextWithOrphans(children)}
        </p>
      )
    }

    return (
      <div
        ref={ref}
        className={`flex ${className || ''} mt-2 w-full`}
      >
        <div className={isFullWidth ? 'w-full' : (widthClass || 'md:w-6/12')}>
          {renderParagraphs()}
        </div>
      </div>
    )
  }
)

HighLight.defaultProps = {
  className: '',
}

export default HighLight
